import React, { useState, useRef } from 'react';

const PinchToZoomAndPanImage = ({ src }) => {
  const [width, setWidth] = useState(100); // Zoom level in percentage (100% = original size)
  const [initialDistance, setInitialDistance] = useState(0); // Initial pinch distance for zoom calculation
  const [translateX, setTranslateX] = useState(0); // Horizontal pan position (X-axis)
  const imgRef = useRef(null); // Ref to access the image DOM element
  const startDrag = useRef(false); // Track dragging state
  const startPosition = useRef({ x: 0, y: 0 }); // Track the position when drag starts

  // Function to calculate the distance between two touch points
  const getDistance = (touches) => {
    const dx = touches[0].pageX - touches[1].pageX;
    const dy = touches[0].pageY - touches[1].pageY;
    return Math.sqrt(dx * dx + dy * dy);
  };

  // Handle touch start (detect two touch points)
  const handleTouchStart = (e) => {
    if (e.touches.length === 2) {
      setInitialDistance(getDistance(e.touches)); // Store the initial distance
    }
  };

  // Handle touch move (calculate zoom level)
  const handleTouchMove = (e) => {
    if (e.touches.length === 2) {
      const currentDistance = getDistance(e.touches);
      const zoomFactor = currentDistance / initialDistance; // Calculate zoom factor
      const newWidth = Math.min(Math.max(100, width * zoomFactor), 300); // Zoom range from 100% to 300%
      setWidth(newWidth); // Update width for zoom
    }
  };

  // Reset the initial distance when touch ends
  const handleTouchEnd = () => {
    setInitialDistance(0); // Reset initial distance when fingers are lifted
  };

  // Handle mouse drag for horizontal panning
  const handleMouseDown = (e) => {
    startDrag.current = true;
    startPosition.current = { x: e.clientX, y: e.clientY };
  };

  const handleMouseMove = (e) => {
    if (startDrag.current) {
      const deltaX = e.clientX - startPosition.current.x; // Horizontal movement
      setTranslateX((prevTranslateX) => prevTranslateX + deltaX); // Update the X-axis translation
      startPosition.current = { x: e.clientX, y: e.clientY };
    }
  };

  const handleMouseUp = () => {
    startDrag.current = false; // Stop dragging
  };

  const handleMouseLeave = () => {
    startDrag.current = false; // Stop dragging when mouse leaves
  };

  return (
    <div
      style={{
        width: `${width}%`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        cursor: 'grab', // Change cursor to indicate drag
      }}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
    >
      <img
        ref={imgRef}
        src={src}
        alt="Zoomable"
        style={{
          width: `100%`, // Dynamically set image width based on zoom level
          height: 'auto', // Maintain aspect ratio
          transform: `translateX(${translateX}px)`, // Apply horizontal pan (scroll)
          transition: 'transform 0.04s ease', // Smooth transition for pan
          cursor: startDrag.current ? 'grabbing' : 'grab', // Change cursor when dragging
        }}
      />
    </div>
  );
};

export default PinchToZoomAndPanImage;